module.exports = __webpack_public_path__ + "595a3e8269a6212430dd28c44d05dcf2.MP3";